export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_4W_44_4W_7_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_4w_44_4w_7_99_usd',
			EUR: 'simple_premium_4w_39_4w_7_99_eur',
			GBP: 'simple_premium_4w_44_4w_7_99_gbp',
			AUD: 'simple_premium_4w_73_4w_11_99_aud',
			CAD: 'simple_premium_4w_73_4w_11_99_cad',
			DKK: 'simple_premium_4w_379_4w_55_2_dkk',
			SEK: 'simple_premium_4w_585_4w_88_sek',
			NOK: 'simple_premium_4w_585_4w_88_nok',
			BRL: 'simple_premium_4w_99_4w_31_2_brl',
			MXN: 'simple_premium_4w_729_4w_103_2_mxn',
			TRY: 'simple_premium_4w_1499_4w_266_4_try',
			ARS: 'simple_premium_4w_58000_4w_10392_ars',
			COP: 'simple_premium_4w_178000_4w_31992_cop',
			CLP: 'simple_premium_4w_42000_4w_7992_clp',
		},
		primer: 'prd_TMt4InDJq7R2',
	},
}
